import { type IBreadcrumbsProps } from '@webapp/core/components/Breadcrumbs'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { ExpenseRequestView } from '@webapp/modules/expense/feature-sets/ExpenseRequestView'
import messages from './messages'

export const ExpenseRequestPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const breadcrumbs = [
    {
      link: url('ExpenseStatusPage', { status: 'pending' }),
      name: intl.formatMessage(messages.expenseStatusBreadcrumb),
    },
    {
      name: intl.formatMessage(messages.pageTitle),
    },
  ] satisfies IBreadcrumbsProps['crumbs']

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={breadcrumbs}
    >
      <ExpenseRequestView />
    </Page>
  )
}
